/* Axiom Supply — Vehicle Fitment Search (homepage bar)
   Year -> Make -> Model. Trucks/Can-Am/Kawasaki route to a fitment COLLECTION;
   Polaris routes to the wheel-bearing PRODUCT (data: window.AXIOM_POLARIS_BEARING,
   load assets/polaris-bearing-fitment.js first). See docs/vehicle-search.md. */
(function () {
  var GARAGE_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M3 21V8l9-5 9 5v13"/><path d="M7 21v-6h10v6"/><path d="M7 12h10"/></svg>';

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // FITMENT dataset + make order now live in assets/vehicle-fitment-data.js
  // (single source of truth, shared with the product-page checker). Loaded
  // before this script via sections/vehicle-search.liquid.
  var FITMENT = (window.AXIOM_FITMENT || []).slice();
  var MAKE_ORDER = window.AXIOM_FITMENT_MAKE_ORDER ||
    ['RAM', 'Ford', 'Chevy / GMC', 'Jeep', 'Toyota', 'Hummer', 'Polaris', 'Can-Am', 'Kawasaki'];
  var PLACEHOLDERS = { year: 'Year', make: 'Make', model: 'Model' };

  var YEARS = (function () {
    var min = 9999, max = 0;
    FITMENT.forEach(function (e) { if (e.start < min) min = e.start; if (e.end > max) max = e.end; });
    var out = [];
    for (var y = max; y >= min; y--) out.push(y);
    return out;
  })();

  if (!window.customElements || customElements.get('vehicle-search')) return;

  customElements.define(
    'vehicle-search',
    class extends HTMLElement {
      connectedCallback() {
        this.year = this.q('year');
        this.make = this.q('make');
        this.model = this.q('model');
        this.submitBtn = this.q('submit');
        this.form = this.querySelector('form');
        this.garageEl = this.querySelector('[data-vs="garage"]');
        this.root = (((window.Shopify || {}).routes || {}).root || '/').replace(/\/$/, '');
        this.candidates = [];
        this.currentEntry = null;
        if (!this.year || !this.form) return;

        this.fill(this.year, YEARS.map(function (y) { return { label: String(y), value: String(y) }; }), 'year');
        this.year.disabled = false;
        this.mark(this.year);

        var self = this;
        this.year.addEventListener('change', function () { self.onYear(); });
        this.make.addEventListener('change', function () { self.onMake(); });
        this.model.addEventListener('change', function () { self.mark(self.model); self.refresh(); });
        this.form.addEventListener('submit', function (e) { self.onSubmit(e); });

        this.renderGarage();
        this.restore();
      }

      q(name) { return this.querySelector('[data-vs="' + name + '"]'); }

      fill(sel, items, key) {
        sel.innerHTML = '';
        var ph = new Option(PLACEHOLDERS[key], '');
        ph.selected = true;
        sel.add(ph);
        items.forEach(function (it) { sel.add(new Option(it.label, it.value)); });
        this.mark(sel);
      }

      mark(sel) { sel.classList.toggle('is-placeholder', sel.value === ''); }

      reset(levels) {
        var self = this;
        levels.forEach(function (k) {
          var sel = self[k];
          sel.innerHTML = '';
          var ph = new Option(PLACEHOLDERS[k], '');
          ph.selected = true;
          sel.add(ph);
          sel.disabled = true;
          self.mark(sel);
        });
      }

      onYear() {
        this.mark(this.year);
        this.reset(['make', 'model']);
        var y = +this.year.value;
        if (y) {
          var makes = MAKE_ORDER.filter(function (m) {
            return FITMENT.some(function (e) { return e.make === m && y >= e.start && y <= e.end; });
          });
          this.fill(this.make, makes.map(function (m) { return { label: m, value: m }; }), 'make');
          this.make.disabled = false;
        }
        this.refresh();
      }

      onMake() {
        this.mark(this.make);
        this.reset(['model']);
        var y = +this.year.value, mk = this.make.value;
        if (mk) {
          this.candidates = FITMENT.filter(function (e) { return e.make === mk && y >= e.start && y <= e.end; });
          var counts = {};
          this.candidates.forEach(function (e) { counts[e.model] = (counts[e.model] || 0) + 1; });
          var opts = this.candidates.map(function (e, i) {
            return { label: counts[e.model] > 1 ? e.model + ' · ' + e.trim : e.model, value: String(i) };
          });
          this.fill(this.model, opts, 'model');
          this.model.disabled = false;
        }
        this.refresh();
      }

      refresh() {
        var v = this.model.value;
        this.currentEntry = (v !== '' && this.candidates[+v]) ? this.candidates[+v] : null;
        this.submitBtn.disabled = !this.currentEntry;
      }

      onSubmit(e) {
        e.preventDefault();
        var entry = this.currentEntry;
        if (!entry) return;
        this.save(entry);
        window.location.href = this.dest(entry);
      }

      dest(entry) { return this.root + '/' + (entry.prod ? 'products/' : 'collections/') + entry.handle; }

      label(entry) {
        return this.year.value + ' ' + entry.make + ' ' + entry.model + (entry.trim ? ' · ' + entry.trim : '');
      }

      save(entry) {
        try {
          localStorage.setItem('axiom_garage', JSON.stringify({
            year: this.year.value, make: entry.make, model: entry.model, trim: entry.trim || '',
            handle: entry.handle, prod: !!entry.prod, label: this.label(entry)
          }));
          window.dispatchEvent(new CustomEvent('axiom:garage-change'));
        } catch (_) {}
      }

      read() {
        try { return JSON.parse(localStorage.getItem('axiom_garage')); } catch (_) { return null; }
      }

      renderGarage() {
        if (!this.garageEl) return;
        var g = this.read();
        if (!g) { this.garageEl.hidden = true; this.garageEl.innerHTML = ''; return; }
        this.garageEl.hidden = false;
        var url = this.root + '/' + (g.prod ? 'products/' : 'collections/') + g.handle;
        this.garageEl.innerHTML =
          '<span class="vehicle-search__garage-label">' + GARAGE_SVG +
          '<span><span class="vs-garage-kicker">Your Garage</span>' + escapeHtml(g.label) + '</span></span>' +
          '<a class="vehicle-search__garage-shop" href="' + url + '">Shop fitment</a>' +
          '<button type="button" class="vehicle-search__garage-clear" data-vs="clear" aria-label="Clear saved vehicle">&times;</button>';
        var self = this;
        this.garageEl.querySelector('[data-vs="clear"]').addEventListener('click', function () { self.clear(); });
      }

      clear() {
        try {
          localStorage.removeItem('axiom_garage');
          window.dispatchEvent(new CustomEvent('axiom:garage-change'));
        } catch (_) {}
        this.renderGarage();
        this.year.value = '';
        this.onYear();
      }

      restore() {
        var g = this.read();
        if (!g) return;
        this.year.value = String(g.year); this.onYear();
        this.make.value = g.make; this.onMake();
        var idx = -1;
        for (var i = 0; i < this.candidates.length; i++) {
          if (this.candidates[i].model === g.model && (this.candidates[i].trim || '') === (g.trim || '')) { idx = i; break; }
        }
        if (idx >= 0) { this.model.value = String(idx); this.mark(this.model); }
        this.refresh();
      }
    }
  );
})();
